// extracted by mini-css-extract-plugin
module.exports = {"section":"Tabs-section-3DGMM","button":"Tabs-button-4Q0iF","buttonActive":"Tabs-buttonActive-16yL1"};